import React from 'react';
import { heights, widths, fonts, spacing } from './../../styles/theme.json';

const SubItems = (props) => {
  const stockItems = props.SubItemList.map((subitem, i) =>
    <li className={'stocklist-entry'} key={i}>
      <h5 className={'stocklist-header'}>{subitem.name}</h5>
      <div className={'details'} dangerouslySetInnerHTML={{__html: subitem.details}} />
      {
        (subitem.link)
        ? <a href={subitem.link} target={'_blank'} className={'stocklist-link link'}>{subitem.link_text}</a>
        : null
      }
    </li>
  );
  return (
    <ul className={'stocklist-entries'}>
      {stockItems}
    </ul>
  );
};

const Stocklist = (props) => {
  const stockListSections = props.data.socklist_data.map((item, i) => {
    return (
      <div className={'stocklist-section'} key={'stocklist-section' + i}>
        <h2 className={'stocklist-headline'}>{item.title}</h2>
        <SubItems SubItemList={item.entries}/>
      </div>
    );
  });

  return (
    <div id={'stocklist-content'}>
      {stockListSections}
    </div>
  );
};

export default Stocklist;



// WEBPACK FOOTER //
// ./src/components/filter-pages/Stocklist.js